"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocation = void 0;
const react_1 = require("react");
const Location = __importStar(require("expo-location"));
const Alert_1 = require("../components/Alert");
const useLocation = () => {
    const [location, setLocation] = react_1.useState(null);
    const [error, setError] = react_1.useState(null);
    const [permissionStatus, setPermissionStatus] = react_1.useState();
    const alert = Alert_1.useAlert();
    const getPermission = async () => {
        let { status } = await Location.requestPermissionsAsync();
        setPermissionStatus(status);
    };
    react_1.useEffect(() => {
        (async () => {
            try {
                let { status } = await Location.requestPermissionsAsync();
                setPermissionStatus(status);
                if (status !== 'granted') {
                    setError('دسترسی به موقعیت جغرافیایی برای برنامه فراهم نیست.');
                    alert({
                        message: 'دسترسی به موقعیت جغرافیایی برای برنامه فراهم نیست.',
                    });
                    return;
                }
                let geoLocation = await Location.getCurrentPositionAsync({});
                setLocation(geoLocation);
            }
            catch (err) {
                // console.log('error in getting loc or access', err);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return { location, error, getPermission, permissionStatus };
};
exports.useLocation = useLocation;
